import { render, staticRenderFns } from "./Heading--Bullet.vue?vue&type=template&id=f5dd36e4&lang=pug&"
import script from "./Heading--Bullet.vue?vue&type=script&lang=js&"
export * from "./Heading--Bullet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports